import styled from 'styled-components';
import { breakpoints, spacing } from '@naf/theme';

export const ListElement = styled.li`
  span {
    font-weight: 500;
    margin-bottom: ${spacing.space12};
    padding: ${spacing.space8} 0 ${spacing.space8} !important;
  }

  p {
    font-weight: 500;
  }

  &:first-child {
    p {
      padding-top: ${spacing.space8};
    }
  }

  &:not(:first-child) {
    p {
      padding-top: ${spacing.space16};
    }
  }

  &:last-child {
    span {
      margin-bottom: 0;
    }
  }

  @media (max-width: ${breakpoints.m}) {
    span {
      margin-bottom: ${spacing.space8};
    }
    &:not(:first-child) {
      p {
        padding-top: ${spacing.space8};
      }
    }
  }
`;
